import { PreloaderApi } from "./PreloaderApi"

export class MockPreloaderApi implements PreloaderApi {
    async showLoadScreen(): Promise<void> {
    }

    async hideLoadScreen(): Promise<void> {
    }

    async setLoaderText(text: string): Promise<void> {
    }

    async setLoaderProgress(progress: number): Promise<void> {
    }
}